module.exports = __webpack_public_path__ + "static/media/medalhas2020-reputacao-21.108fd159.108fd159.png";